<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import { USDLRegex } from 'src/utils/validators'

export default {
  name: 'StudentDetailsTab',
  props: ['validation'],
  data () {
    return {
      statusOptions: this.$store.state.shared.statuses,
      genderOptions: this.$store.state.shared.genders
    }
  },
  mounted () {
  },
  computed: {
    driversLicenseError () {
      const errorMessage = (this.stateAbbrev) ? USDLRegex[this.stateAbbrev].description.join(', ') : ''
      return errorMessage
    },
    ...mapState('students', {
      studentForm: state => state.studentForm,
      addressForm: state => state.addressForm,
      driversLicenseForm: state => state.driversLicenseForm
    }),
    ...mapGetters([
      'stateOptions',
      'suffixOptions'
    ]),
    ...mapGetters([
      'stateOptions',
      'suffixOptions'
    ]),
    ...mapGetters('students', [
      'stateAbbrev'
    ])
  },
  methods: {
    ...mapMutations('students', [
      'updateForm',
      'updateStudentForm',
      'updateAddressForm',
      'updateAdministratorForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}
</script>

<template>
  <div class="layout-padding fit scroll">
    <div class="q-pb-xl">
      <!-- <div class="row justify-end">
        <q-field class="q-pa-md">
          <q-toggle 
            label="Active"
            v-model="studentForm.ACTIVE_IND"
            @input="updateForm({ form: 'studentForm', field: 'ACTIVE_IND', value: studentForm.ACTIVE_IND })"
          />
        </q-field>
      </div> -->
      <div class="q-pb-xl">
        <h5> Drivers License </h5>
        <div class="row">
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Drivers License State"
              :value="driversLicenseForm.LK_STATE_ID"
              :options="stateOptions"
              :after="[
                {icon: 'flag', condition: validation.driversLicenseForm.LK_STATE_ID.$invalid },
                {icon: 'fa fa-check', condition: !validation.driversLicenseForm.LK_STATE_ID.$invalid}
              ]"
              @blur="validation.driversLicenseForm.DRIVERS_LICENSE.$touch"
              @change="val => updateForm({ form: 'driversLicenseForm', field: 'LK_STATE_ID', value: val })"
            />
          </q-field>
          <q-field class="q-pa-md col-4"
            :error="validation.driversLicenseForm.DRIVERS_LICENSE.$error"
            :error-label="driversLicenseError"
          >
            <q-input
              float-label="Drivers License Number"
              :disable="!driversLicenseForm.LK_STATE_ID"
              :value="driversLicenseForm.DRIVERS_LICENSE"
              :after="[
                {icon: 'flag', condition: validation.driversLicenseForm.LK_STATE_ID.$invalid },
                {icon: 'fa fa-check', condition: !validation.driversLicenseForm.LK_STATE_ID.$invalid}
              ]"
              @blur="validation.driversLicenseForm.DRIVERS_LICENSE.$touch"
              @keyup.stop="updateForm({ form: 'driversLicenseForm', field: 'DRIVERS_LICENSE', value: $event.target.value.toUpperCase() })"
              required>
            </q-input>
          </q-field>
        </div>
      </div>
      <div class="q-pb-xl">
        <h5> Details </h5>
        <div class="row">
          <q-field class="q-pa-md col-4"
            :error="validation.studentForm.STUDENT_LAST_NAME.$error"
            error-label="Last name is required"
          >
            <q-input
              float-label="Last Name"
              :value="studentForm.STUDENT_LAST_NAME"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_LAST_NAME.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_LAST_NAME.$invalid}
              ]"
              @blur="validation.studentForm.STUDENT_LAST_NAME.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_LAST_NAME', value: $event.target.value })"
              required>
            </q-input>
          </q-field>
          <q-field 
            class="q-pa-md col-4"
            :error="validation.studentForm.STUDENT_FIRST_NAME.$error"
            error-label="First name is required"
          >
            <q-input
              float-label="First Name"
              :value="studentForm.STUDENT_FIRST_NAME"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_FIRST_NAME.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_FIRST_NAME.$invalid}
              ]"
              @blur="validation.studentForm.STUDENT_FIRST_NAME.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_FIRST_NAME', value: $event.target.value })"
              required>
            </q-input>
          </q-field>
          <q-field class="q-pa-md col-4">
            <q-input
              float-label="Middle Name"
              :value="studentForm.STUDENT_MIDDLE_NAME"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_MIDDLE_NAME', value: $event.target.value })"
              required>
            </q-input>
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Suffix"
              :value="studentForm.STUDENT_SUFFIX"
              :options="suffixOptions"
              @change="val => updateForm({ form: 'studentForm', field: 'STUDENT_SUFFIX', value: val })"
            />
          </q-field>
          <q-field class="q-pa-md col-4">
            <q-datetime
              type="date"
              float-label="Date of Birth"
              format="MM/D/YYYY"
              :value="studentForm.STUDENT_DOB"
              @input="val => updateForm({ form: 'studentForm', field: 'STUDENT_DOB', value: val })"
              required
            >
            </q-datetime>
          </q-field>
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Gender"
              :value="studentForm.STUDENT_GENDER"
              :options="genderOptions"
              @change="val => updateForm({ form: 'studentForm', field: 'STUDENT_GENDER', value: val })"
            />
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-6"
            :error="validation.studentForm.STUDENT_EMAIL.$error"
            error-label="Must be a valid email"
          >
            <q-input
              float-label="Email"
              :value="studentForm.STUDENT_EMAIL"
              @blur="validation.studentForm.STUDENT_EMAIL.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_EMAIL', value: $event.target.value })"
              required>
            </q-input>
          </q-field>
          <q-field 
            class="q-pa-md col-6"
            :error="validation.studentForm.STUDENT_PHONE.$error"
            error-label="Phone must be numeric"
          >
            <q-input
              float-label="Phone"
              :value="studentForm.STUDENT_PHONE"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_PHONE.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_PHONE.$invalid}
              ]"
              @blur="validation.studentForm.STUDENT_PHONE.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_PHONE', value: $event.target.value })"
              required>
            </q-input>
          </q-field>
        </div>
      </div>
    </div>
    <div class="q-pb-xl">
      <h5> Location </h5>
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 1"
            :value="addressForm.ADDRESS_1"
            @keyup.stop="updateForm({ form: 'addressForm', field: 'ADDRESS_1', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 2"
            :value="addressForm.ADDRESS_2"
            @keyup.stop="updateForm({ form: 'addressForm', field: 'ADDRESS_2', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="City"
            :value="addressForm.CITY"
            @keyup.stop="updateForm({ form: 'addressForm', field: 'CITY', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-select
            float-label="State"
            :value="addressForm.LK_STATE_ID"
            :options="stateOptions"
            @change="val => updateForm({ form: 'addressForm', field: 'LK_STATE_ID', value: val })"
          />
        </q-field>
        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Zip"
            :value="addressForm.ZIP_CODE"
            @keyup.stop="updateForm({ form: 'addressForm', field: 'ZIP_CODE', value: $event.target.value })"
            required>
          </q-input>
        </q-field>
      </div>
      <div class="q-pt-xl">
        <h5> Student Notes </h5>
        <q-field class="q-pa-md">
          <q-input
            rows="7"
            type="textarea"
            float-label="Notes"
            :max-height="100"
            :value="studentForm.notes"
            @keyup.stop="updateStudentForm({ field: 'notes', value: $event.target.value })"
          />
        </q-field>
      </div>
    </div>
  </div>
</template>

<style>
</style>
